import { api } from "shared/redux/api"
import { camelizeKeys } from "shared/utils/camelize"

const BASE = "/private/procurement/v1"
const unwrap = (response) => camelizeKeys(response?.data)

// A3 — "Người làm Payment": who will run the payment for this order. The
// create-order form prepends the current user and defaults to them; this just
// supplies additional pickable people.
const procurementDirectoryApi = api.injectEndpoints({
  endpoints: (build) => ({
    // Keyed on `userId` (not the row `id`) so it dedupes against the current
    // user, whom the form identifies by authUser.userId.
    getPaymentAssignees: build.query({
      query: () => ({ url: `${BASE}/order-requests/payment-assignees` }),
      transformResponse: (response) =>
        (Array.isArray(response?.data) ? response.data : []).map((u) => ({
          id: u.userId,
          name: u.fullName,
          email: u.email,
        })),
    }),
    // A5 — the center's representative (first one, per BE) used to prefill a
    // line's delivery contact. Backed by pro.center_representative.
    getCenterRepresentative: build.query({
      query: (centerId) => ({ url: `${BASE}/centers/${centerId}/representative` }),
      transformResponse: unwrap,
    }),
    // GET /private/center/v1?centerId= — pageable center list; the first row's
    // fullAddress is the line's delivery address.
    getCenterAddress: build.query({
      query: (centerId) => ({ url: `/private/center/v1?centerId=${centerId}&page=0&size=1` }),
      // `data` is the center object itself; the older pageable shape
      // ({ data: { data: [center] } }) is still accepted. Falls back to the
      // address parts when fullAddress is empty.
      transformResponse: (response) => {
        const d = response?.data
        const c = Array.isArray(d?.data) ? d.data[0] : d
        if (!c) return ""
        return c.fullAddress || [c.addressNo, c.wardName, c.districtName, c.cityName].filter(Boolean).join(", ")
      },
    }),
  }),
  overrideExisting: false,
})

export const {
  useGetPaymentAssigneesQuery,
  useGetCenterRepresentativeQuery,
  useLazyGetCenterRepresentativeQuery,
  useGetCenterAddressQuery,
  useLazyGetCenterAddressQuery,
} = procurementDirectoryApi
